//@flow
import React from "react"
import ReactGA from "react-ga4"
import { connect } from "react-redux"
import { Route, Switch } from "react-router-dom"
import qs from "qs"
import { setLocale, LOCALE_EN, LOCALE_ES } from "../Intl"
import KioskBackground from "./KioskBackground"
import KioskContent from "./KioskContent"
import WoodburningView from "./WoodburningView"
import BodyView from "./BodyView"
import CommitView from "./CommitView"
import FixedResolutionContainer, {
  setScaleAndOffsets,
  currentScaleFactor
} from "./FixedResolutionContainer"

import type { RouterHistory, Location } from "react-router-dom"
import type { SetLocale } from "../Intl"
import type { SetScale } from "./FixedResolutionContainer"

type Props = {
  currentLocale: string,
  history: RouterHistory,
  location: Location,
  setScale: SetScale,
  setLocale: SetLocale,
  currentScaleFactor: number,
  setScaleAndOffsets: SetScale,
  sessionLastTouched: number,
  sessionStartTime: number
}

ReactGA.initialize(process.env.REACT_APP_GA4_ID)

class Infographic extends React.Component<Props> {
  container: ?HTMLElement
  content: ?HTMLElement

  constructor(props: Props) {
    super(props)
    this.container = null
    this.content = null
  }

  componentDidMount = () => {
    const { location, setLocale } = this.props
    window && window.addEventListener("resize", this.handleWindowResize)
    this.handleWindowResize()
    const locale = location.search
      ? qs.parse(location.search.replace(/^\?/, ""))["locale"]
      : "en"
    setLocale(locale === "es" ? LOCALE_ES : LOCALE_EN)
  }

  componentWillUnmount = () => {
    window && window.removeEventListener("resize", this.handleWindowResize)
  }

  handleWindowResize = () => {
    const { currentScaleFactor, setScaleAndOffsets } = this.props
    if (!window || !this.container || this.container === null) {
      return
    }
    const width = this.container.offsetWidth || 1920
    const height = this.container.offsetHeight || 1080
    const verticalRatio = window.innerHeight / height
    const horizontalRatio = window.innerWidth / width
    const newScale = Math.min(verticalRatio, horizontalRatio, 1)
    if (currentScaleFactor !== newScale) {
      const x = window.innerWidth - width * newScale
      const y = window.innerHeight - height * newScale
      setScaleAndOffsets(newScale, x, y)
    }
  }

  render() {
    const { currentScaleFactor } = this.props
    return (
      <KioskBackground>
        <FixedResolutionContainer
          innerRef={ref => (this.container = ref)}
          scale={currentScaleFactor}
        >
          <KioskContent innerRef={el => (this.content = el)}>
            <Switch>
              <Route
                path="/infographic/section/woodburning"
                component={WoodburningView}
              />
              <Route path="/infographic/section/body" component={BodyView} />
              <Route component={CommitView} />
            </Switch>
          </KioskContent>
        </FixedResolutionContainer>
      </KioskBackground>
    )
  }
}

export default connect(
  state => ({
    currentScaleFactor: currentScaleFactor(state)
  }),
  { setScaleAndOffsets, setLocale }
)(Infographic)



// WEBPACK FOOTER //
// ./src/Kiosk/Infographic.js